import React from "react"
import withStyles from "react-jss"
import colors from "../data/colors"
import {
  HEADER_FADEIN,
  HEADER_FADEOUT,
  SECTION_DURATION,
} from "../data/globalStyles"
import { header } from "../assets/images"

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    height: "100vh",
    width: "100vw",
    background: `url(${header}) no-repeat center center`,
    backgroundSize: "cover",
    animation: ({ show }) =>
      `${
        show ? `$${HEADER_FADEIN}` : `$${HEADER_FADEOUT}`
      } ${SECTION_DURATION} ease-in-out`,
  },
  intro: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: "1rem",
    maxWidth: "700px",
    backgroundColor: "#FFFFFF",
    "@media only screen and (max-width: 1160px)": {
      width: "80%",
      maxWidth: "80%",
      padding: "2rem 0 1.3rem 0",
    },
    "@media only screen and (max-width: 425px)": {
      width: "80%",
      maxWidth: "80%",
      padding: "3rem 0.3rem",
    },
  },
  heading: {
    fontFamily: "Futura",
    fontSize: "calc(30px + (40 - 30) * ((100vw - 300px) / (1600 - 300)))",
    fontWeight: 500,
    lineHeight: 1.4,
    margin: "0.3rem 1rem 1.8rem 1rem",
    textAlign: "center",
    "@media only screen and (max-width: 425px)": {
      fontSize: "30px",
    },
  },
  start: {
    fontFamily: "Futura",
    fontWeight: 500,
    fontSize: "calc(14px + (18 - 12) * ((100vw - 300px) / (1600 - 300)))",
    padding: ".7rem 3rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    textAlign: "center",
    boxSizing: "border-box",
    backgroundColor: colors.orange,
    border: `2px solid ${colors.orange}`,
    color: "#ffffff",
    transition: "background-color 0.2s ease-in-out",
    "&:hover": {
      color: colors.orange,
      backgroundColor: `${colors.white}`,
    },
    "&:focus": {
      color: colors.orange,
      backgroundColor: `${colors.white}`,
    },
  },
  [`@keyframes ${HEADER_FADEIN}`]: {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  [`@keyframes ${HEADER_FADEOUT}`]: {
    from: {
      opacity: 1,
    },
    to: {
      opacity: 0,
    },
  },
  disclaimer: {
    margin: "2rem",
    fontSize: "12px",
    textAlign: "center",
    lineHeight: 1.2,
    maxWidth: "55%",
    "@media only screen and (max-width: 525px)": {
      maxWidth: "80%",
    },
  },
}

const Header = ({ classes, setShow, section, onAnimationEnd }) => {
  return (
    section === "intro" && (
      <header className={classes.container} onAnimationEnd={onAnimationEnd}>
        <div className={classes.intro}>
          <h1 className={classes.heading}>
            Take This Quiz to Find the Perfect Gift for Every Kind of Cook
          </h1>
          <button
            className={classes.start}
            onClick={() =>
              setShow((d) => ({
                ...d,
                intro: false,
                quiz: true,
              }))
            }>
            START
          </button>
          <div className={classes.disclaimer}>
            {
              "All products featured on Epicurious are independently selected by our editors. However, when you buy something through our retail links, we may earn an affiliate commission."
            }
          </div>
        </div>
      </header>
    )
  )
}

export default withStyles(styles)(Header)
